import { useTranslation } from 'react-i18next';
import { useUser } from '../../context/UserContext';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { showToast } from '../utils/toast';

const TimezoneInfo = () => {
  const { userDetails } = useUser();
  const { t } = useTranslation();
  const [hasShownWarning, setHasShownWarning] = useState(false);

  useEffect(() => {
    if (!userDetails || hasShownWarning) return;
    const timer = setTimeout(() => {
      try {
        const deviceTimezone = dayjs.tz.guess();
        const userTimezone = userDetails.timeZone;

        const deviceOffset = dayjs().tz(deviceTimezone).utcOffset();
        const userOffset = dayjs().tz(userTimezone).utcOffset();

        if (deviceOffset === userOffset) return;

        const deviceOffsetFormatted = dayjs().tz(deviceTimezone).format('Z');
        const userOffsetFormatted = dayjs().tz(userTimezone).format('Z');

        showToast(
          'warning',
          t('common:timezoneWarning', {
            deviceTimezone: deviceTimezone,
            deviceOffset: deviceOffsetFormatted,
            userTimezone: userTimezone,
            userOffset: userOffsetFormatted,
            interpolation: { escapeValue: false },
          }),
        );

        setHasShownWarning(true);
      } catch (error) {
        console.error('Error calculating timezone offsets:', error);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [userDetails, hasShownWarning, t]);

  return null;
};
export default TimezoneInfo;
